import { computed } from 'vue'

import type { PageMeta } from '../utils/page-meta-schema'

export const usePageBlockWidth = (pageMeta: PageMeta, isHome: boolean, brand: string) => {
  return computed(() => {
    const isFirstStructureTermPage = (pageMeta?.page === 1 &&
      pageMeta?.pageType === 'structureterm' &&
      pageMeta?.structureTermType === 'structure')

    const isOverviewWide = (isHome || isFirstStructureTermPage) && brand !== 'todaysgolfer'

    return isHome || isOverviewWide ? 'full' : 'normal'
  })
}
